import { createI18n } from "vue-i18n";

import {
  getMarketplaceLocale,
  marketplaceDateTimeFormats,
  marketplaceMessages,
  marketplaceNumberFormats,
} from "@/shared/config/marketplaceConfig";

export default createI18n({
  legacy: false,
  globalInjection: true,
  locale: getMarketplaceLocale(),
  fallbackLocale: "en-US",
  messages: marketplaceMessages,
  datetimeFormats: marketplaceDateTimeFormats,
  numberFormats: marketplaceNumberFormats,
});
